<template>
  <div>
    <h1 class="page-header">{{ $t('paymentannouncement.announcement') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.startDate')
              }}</label>
              <ts-date-picker-input
                v-model="model.start_date"
                @change="onStartDateChange"
              >
              </ts-date-picker-input>
              <div class="validate" v-if="errors.has('start_date')">
                {{ errors.first('start_date') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label">{{
                $t('paymentannouncement.announcementCriteria')
              }}</label>
              <textarea
                rows="3"
                v-model="model.announcement_criteria"
                class="form-control"
                :class="{ 'is-invalid': errors.has('announcement_criteria') }"
                :placeholder="$t('paymentannouncement.placeholder')"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('announcement_criteria')"
              >
                {{ errors.first('announcement_criteria') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.dueDate')
              }}</label>
              <ts-date-picker-input v-model="model.payment_due_date">
              </ts-date-picker-input>
              <div class="validate" v-if="errors.has('payment_due_date')">
                {{ errors.first('payment_due_date') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.endDate')
              }}</label>
              <ts-date-picker-input v-model="model.end_date">
              </ts-date-picker-input>
              <div class="validate" v-if="errors.has('end_date')">
                {{ errors.first('end_date') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label">{{
                $t('paymentannouncement.reminderCriteria')
              }}</label>
              <textarea
                rows="3"
                v-model="model.reminder_criteria"
                class="form-control"
                :class="{ 'is-invalid': errors.has('reminder_criteria') }"
                :placeholder="$t('paymentannouncement.placeholder')"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('reminder_criteria')"
              >
                {{ errors.first('reminder_criteria') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table'
import moment from 'moment'
export default {
  name: 'payment-announcement-form',
  components: {
    DataTable
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      main_program_change: false,
      model: {
        acps_id: null,
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        payment_due_date: moment().format('DD-MM-YYYY'),
        announcement_criteria: '',
        reminder_criteria: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('paymentAnnouncement', ['edit_data']),
    mainPrograms() {
      return this.$store.state.paymentAnnouncement.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subPrograms() {
      return this.$store.state.paymentAnnouncement.sub_programs.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    }
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.$router.push({ name: 'payment-announcement' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        acps_id: null,
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        payment_due_date: moment().format('DD-MM-YYYY'),
        announcement_criteria: '',
        reminder_criteria: ''
      }
    },
    onStartDateChange(newDate) {
      // Don't auto-update when editing
      if (this.updating) return

      const startDate = moment(newDate, 'DD-MM-YYYY')
      if (startDate.isValid()) {
        this.model.end_date = startDate
          .clone()
          .add(1, 'day')
          .format('DD-MM-YYYY')
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    },
    // Auto-update end_date to be one day after start_date
    'model.start_date': {
      handler(newValue) {
        // Skip if updating existing record
        if (this.updating) return

        // Skip if value is invalid
        if (!newValue || newValue === '') return

        // Try to parse the date in different possible formats
        let startDate = moment(newValue, 'DD-MM-YYYY', true)

        // If that fails, try other common formats
        if (!startDate.isValid()) {
          startDate = moment(newValue, 'YYYY-MM-DD', true)
        }

        if (!startDate.isValid()) {
          startDate = moment(newValue)
        }

        // Only update if we have a valid date
        if (startDate.isValid()) {
          this.model.end_date = startDate
            .clone()
            .add(1, 'day')
            .format('DD-MM-YYYY')
        }
      },
      immediate: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('paymentAnnouncement/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
